module.exports = __webpack_public_path__ + "img/Snare_Average.0fa96736.jpg";